import { styled } from '@mui/material/styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { MuiBox } from '../../../../../../../../modules/material';

export const StyledWrapper = styled(MuiBox)({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
});

export const StyledExpandLessIcon = styled(ExpandLessIcon)(({ theme }) => {
  return {
    display: 'flex',
    color: theme.palette.customSuccess.mainCustom,
    marginRight: '4px',
  };
});
